export default "__VITE_ASSET__Cvgh33OI__"